import { memo, useEffect } from 'react';
import { SignIn } from '@clerk/clerk-react';
import AuthShell from '../../auth/AuthShell';
import SignedInRedirect from './SignedInRedirect';
import {
  CLERK_SIGN_IN_URL,
  CLERK_SIGN_UP_URL,
  CLERK_AFTER_SIGN_IN_URL,
} from '../../auth/clerkConfig';
import { logAuthMount } from '../../auth/authLifecycleDebug';

const ClerkSignIn = memo(function ClerkSignIn() {
  useEffect(() => {
    const cleanup = logAuthMount('ClerkSignIn');
    return cleanup;
  }, []);

  return (
    <SignIn
      routing="path"
      path={CLERK_SIGN_IN_URL}
      signUpUrl={CLERK_SIGN_UP_URL}
      fallbackRedirectUrl={CLERK_AFTER_SIGN_IN_URL}
    />
  );
});

function LoginPage() {
  useEffect(() => {
    const cleanup = logAuthMount('LoginPage');
    return cleanup;
  }, []);

  return (
    <SignedInRedirect>
      <AuthShell title="Login">
        <ClerkSignIn />
      </AuthShell>
    </SignedInRedirect>
  );
}

export default memo(LoginPage);
